<template>
<div class="templates" v-cloak>
    <div class="container">
        <!-- <h2>{{h2}}</h2> -->
        <slot></slot>
        <h3  class="d-block d-lg-none text-center responsive-template-category-name text-capitalize mb-4" style="font-size: 20px !important; font-family: 'Avenir Next Medium';">{{ category }} Templates</h3>

        <div class="swiper-container templates-swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide template-section" v-for="singleTemplate in templates" :key="singleTemplate.index">
                    <div class="row ">
                        <div class="col-md-6 my-auto">
                            <div class="mx-auto ml-md-auto mr-md-0 d-flex template-image-wrapper">
                                <div class="d-none d-md-block">
                                    <div class="template-image-overlay"></div>
                                    <div @click="chooseTemplate(singleTemplate)" class="try-template-btn preview-template-enterprise d-flex">
                                        Preview Template
                                    </div>
                                </div>
                                <div>
                                    <img :src="singleTemplate.img" :alt="singleTemplate.alt" width="100%">
                                </div>
                            </div>
                            <div @click="chooseTemplate(singleTemplate)" class="d-flex d-md-none mx-auto try-template-responsive-btn">
                                Preview Template
                            </div>
                        </div>
                        <div class="col-md-6 mt-4 my-md-auto">
                            <!-- <div class="label-text"> For Marketing Teams</div> -->
                            <h3 class="text-left">{{ singleTemplate.title }}</h3>
                            <p style="max-width: 572px">
                                {{ singleTemplate.content }}
                            </p>
                            <a :href="`/templates/${singleTemplate.slug}`" target="_blank" class="get-ltd-btn hvr-grow mb-4 mb-md-0">View Template <span class="ic-arrow"></span> </a>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="arrows container">
                <div class="swiper-button-next templates-swiper-button-next">
                    <!-- <img src="/img/home-v2/arrow-right.svg" alt="" width="50"> -->
                </div>
                <div class="swiper-button-prev templates-swiper-button-prev">
                    <!-- <img src="/img/home-v2/arrow-left.svg" alt="" width="50"> -->
                </div>
            </div>
        </div>
        <div class="d-none d-lg-block swiper-pagination templates-swiper-pagination organize"></div>
    </div>
    <div v-if="template !== null && showModal == true" class="try-it-modal d-block">
        <div class="modal-top-bar">
            This is a preview <span @click="showModal = false" class="ic-exit"></span>
        </div>
        <embed :src="`https://app.startinfinity.com/b/${ template.uid }?pretend`" width="100%" style="border: 0; margin-bottom: -8px; background-color: #fff;">
        <div class="modal-bottom-bar">
            <div class="modal-template">
                <!-- <img :src="template.image" :alt="template.name"> -->
                <span class="d-inline-block content">
                    <div class="title">
                        {{ template.title }}
                    </div>
                    <!-- <div class="content">
                        {{ template.featured ? 'Framework' : template.meta_description }}
                    </div> -->
                </span>
            </div>
            <a :href="`https://app.startinfinity.com/fwd/template-start/${ template.uid }`" target="_blank" class="use-this-template-btn ml-auto">Use This Template <span class="ml-2 ic-arrow"></span></a>
        </div>
    </div>
</div>
</template>
<script>
import Swiper from 'swiper';
export default {
    props: ['h2', 'templates'],
    data() {
        return {
            swiper: null,
            template: null,
            showModal: false
        };
    },
    mounted() {
        this.swiper = new Swiper('.templates-swiper-container', {
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            simulateTouch: false,
            keyboard: true,
            loop: true,
            spaceBetween: 5,
            pagination: {
                el: '.templates-swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.templates-swiper-button-next',
                prevEl: '.templates-swiper-button-prev'
            },
        });
    },
    methods: {
        chooseTemplate(template) {
            this.template = template;
            this.showModal = true;
            dataLayer.push({'event': 'preview_template'});
        }
    },
    destroyed() {
        this.swiper.destroy();
        this.swiper = null;
    },
};
</script>
<style scoped lang="less">
.swiper-slide-next,
.swiper-slide-prev {
    opacity: 0;
    @media (max-width: 991px) {
        opacity: 1;
    }
}
.swiper-pagination {
    cursor: pointer;
}
.swiper-button-prev {
    left: -40px;
}
.swiper-button-next {
    right: -40px;
}
.pre-formatted {
    white-space: pre-line;
    font-family: "Avenir Next Medium";
}
@media(min-width:990px){
    .home-organize-slider{
        display:block;
    }
    .organize-scroll {
        display:none;
    }
    .swiper-slide {
        width: 100%;
    }
}
@media(max-width:990px){
    .swiper-slide {
        width: 100%;
    }
    .arrows {
        display: none;
    }
}
.swiper-container {
    overflow: visible;
    @media (max-width: 768px) {
        // overflow: hidden;
        margin-top: 30px !important;
    }
}
.responsive-template-category-name {
    color: rgb(89, 70, 207);
    width: fit-content;
    margin: auto;
    background-color: rgba(89, 70, 207, 0.1);
    padding: 5px 10px;
    border-radius: 3px;
}
</style>
<style>
.swiper-pagination.organize{
    margin: 20px auto 0;
    text-align: center;
    position: relative;
}
.organize .swiper-pagination-bullet:active,
.organize .swiper-pagination-bullet-active:focus {
    outline:0;
}
.organize .swiper-pagination-bullet-active {
    background: #A039FF !important;
}
.organize .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    margin-right: 25px;
    background: #E0BFFF;
    opacity: 0.5;
}
.swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 10px;
}
.swiper-button-prev {
    background-image: url('/img/home-v2/arrow-left.svg');

} 
.swiper-button-next {
    background-image: url('/img/home-v2/arrow-right.svg');
}

.swiper-button-prev:active {
    outline: none;
}
.swiper-button-prev:focus {
    outline: none;
}
.swiper-button-next:focus {
    outline: none;
}
.swiper-button-next:active {
    outline: none;
}
</style>




// WEBPACK FOOTER //
// resources/js/frontend/components/SingleCategoryTemplates.vue